// Advisor accounts — client copy of server/utils/advisor.js (keep in sync).
// Each admin-dashboard section is Hidden ('h'), View ('v') or Edit ('e'),
// stored in user.permissions as "adv:<section>=<level>". The server enforces
// what an advisor may change; this decides what the app shows.

export const ADVISOR_GROUPS = [
  { labelKey: 'admin.workspace', sections: ['overview', 'orders', 'clients', 'store-analytics'] },
  { labelKey: 'admin.inventory', sections: ['lens-stock', 'frame-stock'] },
  { labelKey: 'admin.team', sections: ['employees', 'employee-statistics', 'employee-badges', 'peer-ratings'] },
  { labelKey: 'admin.network', sections: ['stores', 'central-store', 'labs', 'courier-routes'] },
  { labelKey: 'admin.setup', sections: ['recommendations', 'groups', 'store-branding', 'administration'] },
];

export const ADVISOR_SECTIONS = ADVISOR_GROUPS.flatMap((g) => g.sections);

// The admin-dashboard menu label of each section.
export const SECTION_LABEL_KEYS = {
  overview: 'admin.overview',
  orders: 'admin.orders',
  clients: 'admin.clients',
  'store-analytics': 'admin.storeAnalytics',
  'lens-stock': 'admin.lensStock',
  'frame-stock': 'admin.frameStock',
  employees: 'admin.employees',
  'employee-statistics': 'admin.employeeStatistics',
  'employee-badges': 'admin.employeeBadges',
  'peer-ratings': 'admin.peerRatings',
  stores: 'admin.retailStores',
  'central-store': 'admin.centralStore',
  labs: 'admin.labs',
  'courier-routes': 'admin.courierRoutes',
  recommendations: 'admin.recommendations',
  groups: 'admin.correctionGroups',
  'store-branding': 'admin.storeBranding',
  administration: 'admin.administration',
};

// Admin-dashboard tabs that live under another section.
const TAB_SECTION = { 'other-lenses': 'recommendations' };

const DEFAULT_OVERRIDES = { employees: 'h', administration: 'h' };
export const defaultLevel = (section) => DEFAULT_OVERRIDES[section] || 'v';

export function advisorAccess(permissions) {
  const access = {};
  ADVISOR_SECTIONS.forEach((s) => { access[s] = defaultLevel(s); });
  (permissions || []).forEach((p) => {
    const m = String(p).match(/^adv:([a-z-]+)=([hve])$/);
    if (m && ADVISOR_SECTIONS.includes(m[1])) access[m[1]] = m[2];
  });
  return access;
}

export const sectionOfTab = (tab) => TAB_SECTION[tab] || tab;

// For the signed-in user: null when not an advisor (everything allowed).
export function advisorAccessFor(user) {
  return user?.role === 'advisor' ? advisorAccess(user.permissions) : null;
}
